import React, { useState, useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Dialog, DialogTitle, DialogContent, Typography, Box, IconButton, List, ListItem, ListItemIcon, ListItemText, Divider, Button } from '@mui/material';
import closeIconSvg from '../../assets/svgs/closeIcon.svg';
import micSvg from '../../assets/svgs/mic.svg';
import assessmentSvg from '../../assets/svgs/assessment.svg';
import speechSvg from '../../assets/svgs/speech.svg';
import notTickSvg from '../../assets/svgs/notTick.svg';
import noMicSvg from '../../assets/svgs/noMic.svg';
import arrowSvg from '../../assets/svgs/arrow.svg';
import { getMicrophoneStream } from '../../utils/speechUtils';

import {
    CheckCircle as CheckedIcon,
    Cancel as UncheckedIcon,
    Mic as MicIcon,
    Close as CloseIcon,
    SpeakerNotes as SpeechIcon,
    Quiz as AssessmentIcon
} from '@mui/icons-material';

const useStyles = makeStyles()((theme) => ({
    dialogTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: theme.palette.primary.light + '10',
        opacity: 0.9,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    micPermission: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
    },
    micIcon: {
        color: theme.palette.primary.main,
        marginRight: theme.spacing(1),
        height: '30px',
        width: '30px',
    },
    micPermissionSubtext: {
        width: '95%'
    },
    statusIcon: {
        marginLeft: 'auto',
        height: '30px',
        width: '30px',
    },
    checkedIcon: {
        color: theme.palette.success.main,
        height: '30px',
        width: '30px',
    },
    uncheckedIcon: {
        color: theme.palette.primary.red,
        height: '30px',
        width: '30px',
    },
    section: {
        marginBottom: theme.spacing(2),
    },
    sectionTitle: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
    listItemIcon: {
        minWidth: 40,
        color: theme.palette.primary.main,
        height: '30px',
        width: '30px',
    }
}));

export const DiagnosticTestContentDialog = ({ open, onClose, onRequestPermission, micPermission, onStartTest }) => {
    const { classes } = useStyles();
    const [hasMicPermission, setHasMicPermission] = useState(0);

    const micMessages = {
        0: "Microphone permission has not been granted, please allow to move ahead.",
        1: "Microphone permission has been granted, you can proceed with the test.",
    }

    useEffect(() => {
        // Check for microphone permission
        getMicrophoneStream()
            .then(() => setHasMicPermission(1))
            .catch(() => setHasMicPermission(0));
    }, [micPermission]);

    return (
        // <Dialog
        //     open={open}
        //     onClose={onClose}
        //     maxWidth="sm"
        //     fullWidth
        // >
        //     <DialogTitle className={classes.dialogTitle}>
        //         <Typography variant="h6">Diagnostic Test Information</Typography>
        //         <IconButton
        //             aria-label="close"
        //             onClick={onClose}
        //             className={classes.closeButton}
        //         >
        //             <CloseIcon />
        //         </IconButton>
        //     </DialogTitle>

        //     <DialogContent>
        //         <Box className={classes.micPermission}>
        //             <MicIcon className={classes.micIcon} />
        //             <Box>
        //                 <Typography>
        //                     Microphone Permission
        //                 </Typography>
        //                 <Typography variant="body2" color="textSecondary" className={classes.micPermissionSubtext}>
        //                     {micMessages[hasMicPermission]}
        //                 </Typography>
        //             </Box>
        //             <Box className={classes.statusIcon}>
        //                 {hasMicPermission ? (
        //                     <CheckedIcon className={classes.checkedIcon} />
        //                 ) : (
        //                     <UncheckedIcon className={classes.uncheckedIcon} />
        //                 )}
        //             </Box>
        //         </Box>
        //         {!hasMicPermission && <Box sx={{px:5}}>
        //                 <Button placeholder="Request mic permission" onClick={onRequestPermission} />
        //             </Box>}

        //         <Divider />

        //         <Box className={classes.section}>
        //             <Typography variant="h6" className={classes.sectionTitle}>
        //                 Test Format
        //             </Typography>
        //             <List sx={{pt:0}}>
        //                 <ListItem>
        //                     <ListItemIcon className={classes.listItemIcon}>
        //                         <SpeechIcon />
        //                     </ListItemIcon>
        //                     <ListItemText
        //                         primary="Part 1: Speech Evaluation"
        //                         secondary="You'll be asked to read a paragraph aloud. This helps assess your pronunciation, fluency, and speaking confidence."
        //                     />
        //                 </ListItem>
        //                 <ListItem>
        //                     <ListItemIcon className={classes.listItemIcon}>
        //                         <AssessmentIcon />
        //                     </ListItemIcon>
        //                     <ListItemText
        //                         primary="Part 2: Written Assessment"
        //                         secondary="Complete a comprehensive assessment that adapts to your responses, evaluating your knowledge and understanding across different topics."
        //                     />
        //                 </ListItem>
        //             </List>
        //         </Box>

        //         <Box className={classes.section}>
        //             <Typography variant="body2" color="textSecondary">
        //                 Note: Please ensure you're in a quiet environment for the speech evaluation.
        //                 The test will automatically adjust to your performance level, ensuring accurate placement
        //                 in the appropriate course level.
        //             </Typography>
        //         </Box>

        //         <Box sx={{display: 'flex', justifyContent: 'center'}}>
        //             <Button placeholder="Start Diagnostic Test" variant="contained" onClick={onStartTest} disabled={!hasMicPermission} />
        //         </Box>
        //     </DialogContent>
        // </Dialog>
        <Dialog open={open}
            onClose={onClose} PaperProps={{
                sx: {
                    background: 'none',
                    height: '100%',
                    // width: '100%',
                    alignContent: 'center',
                    boxShadow: 'none',
                    justifyContent: 'center',
                    maxHeight: '90vh',
                    width: '90%',
                    margin: 'auto',
                    overflow: 'visible'
                }
            }} >
            <Box sx={{
                position: 'relative',
                borderRadius: 4,
                borderTop: '5px solid #FFAE00',
                position: 'relative',
                background: '#ffffff',
                paddingTop: 3
            }}>
                <DialogContent sx={{ p: 0 }}>
                    <Typography
                        sx={{
                            fontSize: { xs: '1em', sm: '1.3em', md: '1.5em', lg: '1.5em' },
                            fontFamily: '"Quicksand", sans-serif',
                            fontWeight: '700',
                            textAlign: 'center'
                        }}
                    >
                        Diagnostic Test Information
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: 4 }}>
                        {hasMicPermission ?
                            <img style={{ width: '8%' }} src={micSvg} alt="" />
                            : <img style={{ width: '8%' }} src={noMicSvg} alt="" />}
                        <Typography
                            sx={{
                                fontSize: { xs: '0.8em', md: '1.2em', lg: '1.4em' },
                                fontFamily: '"Quicksand", sans-serif',
                                fontWeight: '700',
                                textAlign: 'left',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                marginLeft: 3

                            }}
                        >
                            Microphone
                            <Typography
                                sx={{
                                    fontSize: { xs: '0.7em', md: '.8em', lg: '.8em' },
                                    color: hasMicPermission ? '#0F67B1' : '#FF0000',
                                    fontFamily: '"Quicksand", sans-serif',
                                    fontWeight: '600',
                                }}
                            >{micMessages[hasMicPermission]}</Typography>
                        </Typography>
                        {!hasMicPermission && <Box sx={{
                            mb: 1, ml: 3, background: 'linear-gradient(0deg, #CCCCCC -2.68%, #E6E6E6 31.68%, #F8F8F8 64.23%, #FFFFFF 87.74%)',
                            padding: '3px',
                            borderRadius: '50px'
                        }}>
                            <Button sx={{
                                background: 'linear-gradient(to top, #2a8307, #2d9106, #319f06, #34ad04, #37bb03, #3fc40e, #46cc17, #4dd51e, #59da2b, #63de36, #6de341, #77e74a)',
                                padding: '5px 20px',
                                borderRadius: '50px',
                                // border: '3px solid lightgrey'
                            }} onClick={onRequestPermission}>
                                <Typography sx={{
                                    fontSize: '1em',
                                    fontFamily: '"Quicksand", sans-serif',
                                    fontWeight: '600',
                                    textAlign: 'center',
                                    color: '#ffffff'
                                }}>
                                    Allow
                                </Typography>
                            </Button>
                        </Box>}
                    </Box>
                    <Box sx={{ px: 4 }}>
                        <Typography
                            sx={{
                                fontSize: '1.5em',
                                fontFamily: '"Quicksand", sans-serif',
                                fontWeight: '700',
                                textAlign: 'left'
                            }}
                        >
                            Test Instructions
                        </Typography>
                        <Box>
                            <Box sx={{ p: 1, display: 'flex', justifyContent: 'flex-start' }}>
                                <img style={{ width: '8%' }} src={speechSvg} alt="" />
                                <Typography
                                    sx={{
                                        fontSize: { xs: '0.8em', md: '1em', lg: '1.2em' },
                                        fontFamily: '"Quicksand", sans-serif',
                                        fontWeight: '600',
                                        textAlign: 'left',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-start',
                                        marginLeft: 3

                                    }}
                                >
                                    Part 1: Read the paragraph shown on the screen out loud.
                                </Typography>
                            </Box>
                            <Box sx={{ p: 1, display: 'flex', justifyContent: 'flex-start' }}>
                                <img style={{ width: '8%' }} src={assessmentSvg} alt="" />
                                <Typography
                                    sx={{
                                        fontSize: { xs: '0.8em', md: '1em', lg: '1.2em' },
                                        fontFamily: '"Quicksand", sans-serif',
                                        fontWeight: '600',
                                        textAlign: 'left',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-start',
                                        marginLeft: 3

                                    }}
                                >
                                    Part 2: You will be assigned a course after reading.
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ px: 4, py: 4, background: '#CBCBCB33', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', }}>
                        <Typography
                            sx={{
                                fontSize: '0.7em',
                                fontFamily: '"Quicksand", sans-serif',
                                fontWeight: '500',
                            }}
                        >Note: Please ensure you're in a quiet environment for the speech evaluation. The test will automatically adjust to your performance level, ensuring accurate placement in the appropriate course level.</Typography>
                    </Box>
                </DialogContent>
                <Box sx={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }} onClick={onClose}>
                    <img style={{ width: '70%' }} src={closeIconSvg} alt="" />
                </Box>
                <Box sx={{
                    background: 'linear-gradient(0deg, #CCCCCC -2.68%, #E6E6E6 31.68%, #F8F8F8 64.23%, #FFFFFF 87.74%)',
                    left: '50%',
                    borderRadius: '50px',
                    padding: '5px 5px',
                    transform: 'translateX(-50%)',
                    position: 'absolute',
                    bottom: '-30px',
                    width: { xs: '60%', sm: 'auto' }, // Adjust width to ensure it fits smaller screens
                }}>

                    <Button
                        sx={{
                            background: !hasMicPermission ? 'linear-gradient(to top, #454545, #555555, #656565, #757575, #868686, #959595, #a4a4a4, #b3b3b3, #c4c4c4, #d5d5d5, #e6e6e6, #f8f8f8);'
                                : 'linear-gradient(to top, #ff6300, #ff7c00, #ff9400, #ffaa00, #ffbf00, #ffc80b, #ffd116, #ffda20, #ffd91a, #ffd814, #ffd60b, #ffd500)',
                            color: '#FFFFFF',
                            borderRadius: '50px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: { xs: '5px 10px', sm: '10px 20px' },
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
                            '&:hover': {
                                background: 'linear-gradient(to top, #ff6300, #ff7c00, #ff9400, #ffaa00, #ffbf00)', // Slightly adjust the gradient on hover
                                boxShadow: '0 6px 10px rgba(0, 0, 0, 0.3)', // Enhance the shadow on hover for a pop-out effect
                            },
                            '&.Mui-disabled': {
                                color: '#FFFFFF',
                            },
                        }}
                        onClick={onStartTest} disabled={!hasMicPermission}
                    >
                        <Typography
                            sx={{
                                fontWeight: '700',
                                fontFamily: '"Quicksand", sans-serif',
                                fontSize: { xs: '1em', sm: '1.5em' },
                                zIndex: 2, // Ensure the text is above the glossy effect
                            }}
                        >
                            Start Test!
                        </Typography>
                        <img
                            style={{
                                width: '15%',
                                maxWidth: '100%',
                                marginTop: '5px',
                                height: 'auto',
                                zIndex: 2, // Ensure the image is above the glossy effect
                            }}
                            src={arrowSvg}
                            alt=""
                        />
                    </Button>
                </Box>
            </Box>

        </Dialog >

        // <Dialog open={open} PaperProps={{
        //     sx: {
        //         background: 'none',
        //         height: '100%',
        //         width: '100%',
        //         alignContent: 'center',
        //         boxShadow: 'none',
        //         justifyContent: 'center',
        //     }
        // }} >
        //     <Box sx={{ position: 'relative' }}>
        //         <DialogContent sx={{
        //             borderRadius: 4,
        //             borderTop: '5px solid #FFAE00',
        //             position: 'relative',
        //             background: '#ffffff'
        //         }}>
        //             <Typography
        //                 sx={{
        //                     fontSize: { xs: '1em', sm: '1.3em', md: '1.5em', lg: '1.5em' },
        //                     fontFamily: '"Quicksand", sans-serif',
        //                     fontWeight: '700',
        //                     textAlign: 'center'
        //                 }}
        //             >
        //                 Diagnostic Test Information
        //             </Typography>
        //             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 2 }}>
        //                 {hasMicPermission ?
        //                     <img style={{ width: '8%' }} src={micSvg} alt="" />
        //                     : <img style={{ width: '8%' }} src={noMicSvg} alt="" />}
        //                 <Typography
        //                     sx={{
        //                         fontSize: '0.8em',
        //                         fontFamily: '"Quicksand", sans-serif',
        //                         fontWeight: '700',
        //                         textAlign: 'left',
        //                         display: 'flex',
        //                         flexDirection: 'column',
        //                         justifyContent: 'flex-start',
        //                         marginLeft: 3

        //                     }}
        //                 >
        //                     Microphone
        //                     <Typography
        //                         sx={{
        //                             fontSize: '0.7em',
        //                             color: hasMicPermission ? '#42AF3C' : '#FF0000',
        //                             fontFamily: '"Quicksand", sans-serif',
        //                             fontWeight: '600',
        //                         }}
        //                     >{micMessages[hasMicPermission]}</Typography>
        //                 </Typography>
        //                 {!hasMicPermission && <Box sx={{
        //                     mb: 1, ml: 3, background: 'linear-gradient(0deg, #CCCCCC -2.68%, #E6E6E6 31.68%, #F8F8F8 64.23%, #FFFFFF 87.74%)',
        //                     padding: '3px',
        //                     borderRadius: '50px'
        //                 }}>
        //                     <Button sx={{
        //                         background: 'linear-gradient(to top, #2a8307, #2d9106, #319f06, #34ad04, #37bb03, #3fc40e, #46cc17, #4dd51e, #59da2b, #63de36, #6de341, #77e74a)',
        //                         padding: '5px 20px',
        //                         borderRadius: '50px',
        //                         // border: '3px solid lightgrey'
        //                     }} onClick={onRequestPermission}>
        //                         <Typography sx={{
        //                             fontSize: '1em',
        //                             fontFamily: '"Quicksand", sans-serif',
        //                             fontWeight: '600',
        //                             textAlign: 'center',
        //                             color: '#ffffff'
        //                         }}>
        //                             Allow
        //                         </Typography>
        //                     </Button>
        //                 </Box>}
        //             </Box>

        //             <Box sx={{
        //                 px: 3,
        //                 height: '50vh',
        //                 overflowY: 'scroll',
        //                 '&::-webkit-scrollbar': {
        //                     width: '6px',
        //                 },
        //                 '&::-webkit-scrollbar-track': {
        //                     borderRadius: '10px',
        //                 },
        //                 '&::-webkit-scrollbar-thumb': {
        //                     background: '#F5F5F5',
        //                     borderRadius: '10px',
        //                 },
        //                 '&:hover, &:focus-within': {
        //                     '&::-webkit-scrollbar-thumb': {
        //                         background: 'lightgrey',
        //                         width: '12px',
        //                         cursor: 'pointer',
        //                     },
        //                 },
        //             }}>
        //                 <Typography
        //                     sx={{
        //                         fontSize: '1.5em',
        //                         fontFamily: '"Quicksand", sans-serif',
        //                         fontWeight: '700',
        //                         textAlign: 'left'
        //                     }}
        //                 >
        //                     Test Format
        //                 </Typography>
        //                 <Box>
        //                     <Box sx={{ p: 1, display: 'flex', justifyContent: 'flex-start' }}>
        //                         <img style={{ width: '8%' }} src={speechSvg} alt="" />
        //                         <Typography
        //                             sx={{
        //                                 fontSize: '0.8em',
        //                                 fontFamily: '"Quicksand", sans-serif',
        //                                 fontWeight: '600',
        //                                 textAlign: 'left',
        //                                 display: 'flex',
        //                                 flexDirection: 'column',
        //                                 justifyContent: 'flex-start',
        //                                 marginLeft: 3

        //                             }}
        //                         >
        //                             Part 1: Speech Evaluation
        //                             <Typography
        //                                 sx={{
        //                                     fontSize: '0.7em',
        //                                     fontFamily: '"Quicksand", sans-serif',
        //                                     fontWeight: '500',
        //                                 }}
        //                             >You'll be asked to read a paragraph aloud. This helps assess your pronunciation, fluency, and speaking confidence.</Typography>
        //                         </Typography>
        //                     </Box>
        //                     <Box sx={{ p: 1, display: 'flex', justifyContent: 'flex-start' }}>
        //                         <img style={{ width: '8%' }} src={assessmentSvg} alt="" />
        //                         <Typography
        //                             sx={{
        //                                 fontSize: '0.8em',
        //                                 fontFamily: '"Quicksand", sans-serif',
        //                                 fontWeight: '600',
        //                                 textAlign: 'left',
        //                                 display: 'flex',
        //                                 flexDirection: 'column',
        //                                 justifyContent: 'flex-start',
        //                                 marginLeft: 3

        //                             }}
        //                         >
        //                             Part 2: Written Assessment
        //                             <Typography
        //                                 sx={{
        //                                     fontSize: '0.6em',
        //                                     fontFamily: '"Quicksand", sans-serif',
        //                                     fontWeight: '500',
        //                                 }}
        //                             >Complete a comprehensive assessment that adapts to your responses, evaluating your knowledge and understanding across different topics.</Typography>
        //                         </Typography>
        //                     </Box>
        //                     <Box sx={{ px: 4, py: 4, background: '#CBCBCB33', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', }}>
        //                         <Typography
        //                             sx={{
        //                                 fontSize: '0.6em',
        //                                 fontFamily: '"Quicksand", sans-serif',
        //                                 fontWeight: '500',
        //                             }}
        //                         >Note: Please ensure you're in a quiet environment for the speech evaluation. The test will automatically adjust to your performance level, ensuring accurate placement in the appropriate course level.</Typography>
        //                     </Box>
        //                 </Box>
        //             </Box>
        //         </DialogContent>
        //         <Box sx={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }} onClick={onClose}>
        //             <img style={{ width: '70%' }} src={closeIconSvg} alt="" />
        //         </Box>
        //         <Box sx={{
        //             background: 'linear-gradient(0deg, #CCCCCC -2.68%, #E6E6E6 31.68%, #F8F8F8 64.23%, #FFFFFF 87.74%)',
        //             left: '50%',
        //             borderRadius: '50px',
        //             padding: '5px 5px',
        //             transform: 'translateX(-50%)',
        //             position: 'absolute',
        //             bottom: '-30px',
        //             width: { xs: '60%', sm: 'auto' }, // Adjust width to ensure it fits smaller screens
        //         }}>
        //             <Button
        //                 sx={{
        //                     background: !hasMicPermission ? 'linear-gradient(to top, #454545, #555555, #656565, #757575, #868686, #959595, #a4a4a4, #b3b3b3, #c4c4c4, #d5d5d5, #e6e6e6, #f8f8f8);'
        //                         : 'linear-gradient(to top, #ff6300, #ff7c00, #ff9400, #ffaa00, #ffbf00, #ffc80b, #ffd116, #ffda20, #ffd91a, #ffd814, #ffd60b, #ffd500)',
        //                     color: '#FFFFFF',
        //                     borderRadius: '50px',
        //                     display: 'flex',
        //                     justifyContent: 'center',
        //                     alignItems: 'center',
        //                     padding: { xs: '5px 10px', sm: '10px 20px' },
        //                     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
        //                     '&:hover': {
        //                         background: 'linear-gradient(to top, #ff6300, #ff7c00, #ff9400, #ffaa00, #ffbf00)', // Slightly adjust the gradient on hover
        //                         boxShadow: '0 6px 10px rgba(0, 0, 0, 0.3)', // Enhance the shadow on hover for a pop-out effect
        //                     },
        //                     '&.Mui-disabled': {
        //                         color: '#FFFFFF',
        //                     },
        //                 }}
        //                 onClick={onStartTest} disabled={!hasMicPermission}
        //             >
        //                 <Typography
        //                     sx={{
        //                         fontWeight: '700',
        //                         fontFamily: '"Quicksand", sans-serif',
        //                         fontSize: { xs: '1em', sm: '1.5em' },
        //                         zIndex: 2, // Ensure the text is above the glossy effect
        //                     }}
        //                 >
        //                     Start Test!
        //                 </Typography>
        //                 <img
        //                     style={{
        //                         width: '15%',
        //                         maxWidth: '100%',
        //                         marginTop: '5px',
        //                         height: 'auto',
        //                         zIndex: 2, // Ensure the image is above the glossy effect
        //                     }}
        //                     src={arrowSvg}
        //                     alt=""
        //                 />
        //             </Button>
        //         </Box>
        //     </Box>

        // </Dialog >
    );
};